const topbar = {
    docs: 'Documentos',
    help: 'Ajuda',
};
export default Object.freeze(topbar);
